var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "merch"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "merch__content"
  }, [_c('p', {
    staticClass: "merch__title"
  }, [_vm._v("Встречайте новый мерч 05.ru")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('GGLink', {
    staticClass: "merch__link cc-link cc-link_wu",
    attrs: {
      "to": _vm.merchLink
    }
  }, [_c('button', {
    staticClass: "merch__button-el",
    attrs: {
      "size": "49",
      "fluid": ""
    }
  }, [_vm._v("Ого, хочу!")])])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "merch__bg"
  }, [_c('img', {
    staticClass: "merch__bg_desktop",
    attrs: {
      "src": require("./asset/merch-bg.jpg"),
      "srcset": require("./asset/merch-bg.jpg") + " 1px, " + require("./asset/merch-bg@2x.jpg") + " 2x",
      "alt": "Мерч 05.ru"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "merch__bg_mobile",
    attrs: {
      "src": require("./asset/merch-bg_mobile.png"),
      "srcset": require("./asset/merch-bg_mobile.png") + " 1px, " + require("./asset/merch-bg_mobile@2x.png") + " 2x",
      "alt": "Мерч 05.ru"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "merch__img-wrap"
  }, [_c('img', {
    staticClass: "merch__img-center",
    attrs: {
      "src": require("./asset/merch-img-center.png"),
      "srcset": require("./asset/merch-img-center.png") + " 1px, " + require("./asset/merch-img-center@2x.png") + " 2x"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "merch__img-left",
    attrs: {
      "src": require("./asset/merch-img-left.png"),
      "srcset": require("./asset/merch-img-left.png") + " 1x, " + require("./asset/merch-img-left@2x.png") + " 2x"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "merch__img-right",
    attrs: {
      "src": require("./asset/merch-img-right.png"),
      "srcset": require("./asset/merch-img-right.png") + " 1x, " + require("./asset/merch-img-right@2x.png") + " 2x"
    }
  })]);
}]

export { render, staticRenderFns }